import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function SelectionText({ label }: { label: string }) {
    const theme = useTheme();

    return (
        <Typography
            component="span"
            variant="body2"
            fontWeight={600}
            color={theme.palette.neutral.N_700}
        >
            {label}
        </Typography>
    );
}
